// Constants for DataXPLR feature

export const DRAFT_STORAGE_KEY = 'dataxplr_draft_conversation';

export const CONVERSATION_TYPE = {
  IDEATION: 'ideation_xplr',
  SOLUTION: 'solution_xplr',
} as const;

export const FIELD_TYPE_OPTIONS = [
  // Ideation group
  { value: 'current_process', label: 'Current Process', group: 'Ideation' },
  { value: 'expected_impact', label: 'Expected Impact', group: 'Ideation' },
  { value: 'ideas_of_improvement', label: 'Specific Idea(s) for Improvement', group: 'Ideation' },
  { value: 'key_performance_indicator', label: 'Key Performance Indicators', group: 'Ideation' },
  // Solution group
  {
    value: 'opportunity_statement_solutionxplr',
    label: 'Opportunity Statement',
    group: 'Solution',
  },
  { value: 'current_process_solutionxplr', label: 'Current Process (Solution)', group: 'Solution' },
  {
    value: 'proposed_enhancements_solutionxplr',
    label: 'Proposed Enhancements',
    group: 'Solution',
  },
  {
    value: 'estimated_impact_solutionxplr',
    label: 'Estimated Impact (Solution)',
    group: 'Solution',
  },
];

export const SORT_LABELS: Record<string, string> = {
  newest_first: 'Newest First',
  oldest_first: 'Oldest First',
  name_asc: 'Name (A-Z)',
  name_desc: 'Name (Z-A)',
  most_intakes: 'Most Intakes',
  least_intakes: 'Least Intakes',
};

// All category options — used by both the DataXPLR sidebar and RightChatDrawer
export const CATEGORY_OPTIONS = [
  { value: 'All', label: 'All' },
  // { value: 'Ideation XPLR', label: 'Ideation XPLR' },
  // { value: 'Solution XPLR', label: 'Solution XPLR' },
  { value: 'Current Process', label: 'Current Process' },
  { value: 'Expected Impact', label: 'Expected Impact' },
  { value: 'Specific Idea(s) for Improvement', label: 'Specific Idea(s) for Improvement' },
  { value: 'Key Performance Indicators', label: 'Key Performance Indicators' },
  // Solution XPLR
  { value: 'Opportunity Statement', label: 'Opportunity Statement' },
  { value: 'Current Process (Solution)', label: 'Current Process (Solution)' },
  { value: 'Proposed Enhancements', label: 'Proposed Enhancements' },
  { value: 'Estimated Impact (Solution)', label: 'Estimated Impact (Solution)' },
];
